import React from 'react';
import { FormattedMessage } from 'react-intl';

const MessageOverview = ({ className = '' }) => {
	return (
		<div className={`border p-5 pt-6 rounded-lg shadow-lg ${className}`}>
			<p className='text-lg font-medium pb-3'>
				<FormattedMessage id={'DASHBOARD.OVERVIEW.TITLE'} />
			</p>
			<div className='flex items-baseline'>
				<span className="text-4xl font-bold text-[#173F5C]">20.000</span>
				<span className="ml-2 text-base font-normal text-[#7C7C7C]">
					<FormattedMessage id={'DASHBOARD.OVERVIEW.UNIT'} />
				</span>
			</div>
			<div className="mt-4 ">
				<div className="flex items-center justify-between py-6 border-t border-[#F6F6F6] text-base">
					<span className="text-[#7C7C7C]"><FormattedMessage id={'DASHBOARD.OVERVIEW.TEXT_MESSAGES'} /></span>
					<span className="text-[#7C7C7C] font-bold">4,968</span>
				</div>
				<div className="flex items-center justify-between py-6 border-t border-[#F6F6F6] text-base">
					<span className="text-[#7C7C7C]"><FormattedMessage id={'DASHBOARD.OVERVIEW.VOICE_MESSAGES'} /></span>
					<span className="text-[#7C7C7C] font-bold">15,032</span>
				</div>
				<div className="flex items-center justify-between py-6 border-t border-[#F6F6F6] text-base">
					<span className="text-[#7C7C7C]"><FormattedMessage id={'DASHBOARD.OVERVIEW.TOTAL_CALL_DURATION'} /></span>
					<span className="text-[#7C7C7C] font-bold">01:24:43</span>
				</div>
				<div className="flex items-center justify-between py-6 border-t border-[#F6F6F6] text-base">
					<span className="text-[#7C7C7C]"><FormattedMessage id={'DASHBOARD.OVERVIEW.AVG_CALL_DURATION'} /></span>
					<span className="text-[#7C7C7C] font-bold">00:01:23</span>
				</div>
			</div>

		</div>
	);
};

export { MessageOverview };


